import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { APP_VERSION } from '../version';
import '../styles/DynamicPanel.css';
import '../styles/Support.css';

/**
 * Zeigt die aktuell installierte myboki.me-Version an.
 * Erreichbar über Hamburger-Menü > Support > Version.
 * Nutzt bewusst dieselbe Panel-Struktur/CSS wie Support.js, um im
 * Hamburger-Menü optisch konsistent zu bleiben.
 */
const VersionInfo = ({ onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="dynamic-panel">
      <div className="support-power-panel">
        <div className="support-power-headline">
          <div className="support-headline-left">
            <span className="support-headline-icon">🏷️</span>
            <h2 className="support-headline-title">{t('version.title') || 'Version'}</h2>
          </div>
        </div>

        <div className="support-info-panel">
          <div className="info-panel-header">
            <h3 className="info-panel-title">{t('version.current') || 'Aktuell installierte Version'}</h3>
          </div>
          <p className="version-number-display">myboki.me v{APP_VERSION}</p>
          <p className="info-panel-hint">{t('version.upToDate') || 'Du nutzt die aktuellste Version.'}</p>
        </div>
      </div>
    </div>
  );
};

export default VersionInfo;
